import React from 'react';
import { MenuItem } from '@mui/material';
import { useSelector } from 'react-redux';
import { getWorkTimeAccess, getAllWorkSchdule } from '../../../../../reduxToolkit/EmployeeContractors/EmployeeContractorsSlice';
import CustomModal from '../../../../../components/Modal/CustomModal';
import { CustomSelectAndChildren } from '../../../../../components/CustomSelectAndChildren';
import WorkShiftTable from '../Table/WorkShiftTable';
import CustomTable from '../../../../../components/table/CustomTable';
import WorkShift from '../Functionality/WorkShift';
import {VIEW_TYPE} from "../../../../../enums/ViewType";

const AddWorkShiftsEnrollment = ({ open, onClose, workshiftsList, setWorkshiftsList }) => {

    const workShiftAccessTime = useSelector(getWorkTimeAccess);
    const workShiftSchedule = useSelector(getAllWorkSchdule);

    const { tableId, searchId, thead, tbody, pagination, page, setPage, rowsPerPage, setRowsPerPage } = WorkShiftTable({
        data: workShiftAccessTime,
        view: VIEW_TYPE.GRID.name
    });
    const { workShift, handleSetListWorkShift, handleWorkShift, isValidWorkShift, setIsValidWorkShift, emptyFields, setEmptyFields, reset } = WorkShift({
        workShiftAccessTime, workShiftSchedule, page, setPage, rowsPerPage, setRowsPerPage, workShiftsList: workshiftsList, setWorkShiftsList: setWorkshiftsList
    });

    return (<CustomModal
        title={'add'}
        size='lg'
        buttonConfirm='confirm'
        show={open}
        onHide={() => {
            handleSetListWorkShift(null);
            reset();
            onClose();
        }}
        onConfirm={() => {
            if(!workShift){
                setEmptyFields(true);
                return;
            }
            setEmptyFields(false);

            if(workShiftAccessTime?.content?.length === 0){
                setIsValidWorkShift(false);
                return;
            }
            setIsValidWorkShift(true);

            handleSetListWorkShift(workShift);
            onClose();
        }}
    >
        <div className={'row'}>
            <div className='col-sm-12 col-xxl-12 col-lg-12'>
                <CustomSelectAndChildren
                    id={"slt_awse_work_shift"}
                    name={"workShift"}
                    trans={"schedule_access"}
                    onChange={(e) => {
                        handleWorkShift(e);
                    }}
                    value={workShift?.id}
                    isValid={isValidWorkShift}
                    isValidText={"select_a_work_shift_with_assigned_zones"}
                    showNoSelectionOption={false}
                    required={true}
                    emptyFields={emptyFields}
                >
                    {workShiftSchedule && workShiftSchedule.filter((item) => !workshiftsList?.some((selected) => selected?.id === item?.id)).map((item) => (
                        <MenuItem key={item?.id} value={item?.id}>
                            {item?.name}
                        </MenuItem>
                    ))}
                </CustomSelectAndChildren>
            </div>
            {workShift != '' && workShift != null && workShiftAccessTime && workShiftAccessTime?.content?.length > 0 &&
                <>
                    <div className='col-12'>
                        <CustomTable
                            tableId={tableId}
                            searchId={searchId}
                            thead={thead}
                            tbody={tbody}
                            columnActions={false}
                            inModal={true}
                        />
                    </div>
                    {pagination()}
                </>
            }
        </div>
    </CustomModal>
    );
};

export default AddWorkShiftsEnrollment;
